import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      width: 'calc(100% - 13px)',
      borderTop: '1px solid #EBEBEB',
      '&:last-of-type': {
        borderBottom: '1px solid #EBEBEB',
      },
    },
    box__inner: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      padding: '5.5px 0',
      minHeight: 45,
    },
    col: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '&:nth-of-type(1)': {
        width: 110,
      },
      '&:nth-of-type(2)': {
        width: 70,
      },
      '&:nth-of-type(3)': {
        width: 100,
      },
      '&:nth-of-type(4)': {
        width: 80,
      },
      '&:nth-of-type(5)': {
        width: 70,
      },
      '&:nth-of-type(6)': {
        width: 75,
      },
      '&:nth-of-type(7)': {
        width: 60,
      },
      '&:nth-of-type(8)': {
        width: 80,
      },
      '&:nth-of-type(9)': {
        width: 70,
      },
      '&:nth-of-type(10)': {
        width: 95,
      },
      '&:nth-of-type(11)': {
        width: 65,
        '& div:first-of-type': {
          width: 20,
          minWidth: 20,
          height: 20,
          '& > *': {
            width: '100%',
            height: '100%',
            verticalAlign: 'unset',
          },
        },
      },
    },
    delete: {
      display: 'flex',
      background: 'transparent',
      outline: 'none',
      border: 'none',
      width: 20,
      minWidth: 20,
      height: 20,
      padding: 0,
      cursor: 'pointer',
      transition: '0.3s',
      '& svg': {
        width: 12,
        height: 15,
        margin: 'auto',
      },
      '&:hover': {
        opacity: 0.7,
      },
    },
    open: {
      '& > div:nth-of-type(2)': {
        maxHeight: 87.5,
        minHeight: 87.5,
        opacity: 1,
      },
    },
    fixedCol: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      background: '#F8F8F8',
      borderTop: '1px solid #EBEBEB',
      height: 87.5,
      minHeight: 0,
      maxHeight: 0,
      transition: '0.3s',
      overflow: 'hidden',
      opacity: 0,
    },
  })
)
export default useStyles
